import * as React from 'react';
import { Link } from 'react-router';
import { IconType, DsiSvgIcon as SvgIcon } from '../General/SvgIcon';
import styled, { keyframes } from 'styled-components';
import { rem, darken } from 'polished';
import { __ } from 'react-i18n/lib';

export interface Props {
  id: string;
  isFavorite: boolean;
  isCompare?: boolean;
  addToFavorite: (id) => void;
  hasFavourite?: boolean;
  showCompareIcon?: boolean;
  addToCompare: (id) => void;
  showCloseIcon?: boolean;
  onClose?: (id: any) => void;
}

function FavoriteCompare({
  isFavorite,
  isCompare,
  addToFavorite,
  id,
  hasFavourite = true,
  showCompareIcon,
  addToCompare,
  showCloseIcon,
  onClose
}: Props) {
  const [isFavoriteP, setIsFavoriteP] = React.useState(isFavorite);
  const [iscompareP, setIsCompareP] = React.useState(isCompare);
  const [isHoverFav, setIsHoverFav] = React.useState(false);
  const [isHoverComp, setIsHoverComp] = React.useState(false);

  React.useEffect(() =>{
    setIsCompareP(isCompare);
  },[isCompare])

  const onSetIsHoverFav = e => {
    setIsHoverFav(true);
  };
  const offSetIsHoverFav = e => {
    setIsHoverFav(false);
  };

  const onSetIsHoverComp = e => {
    setIsHoverComp(true);
  };
  const offSetIsHoverComp = e => {
    setIsHoverComp(false);
  };

  return (
    <Wrapper>
      {showCompareIcon ? 
          <StyledLink
            onMouseEnter={onSetIsHoverComp}
            onMouseLeave={offSetIsHoverComp}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              setIsCompareP(!iscompareP);
              addToCompare(id);
              return true;
            }}
          >
            <SvgIcon
              icon={IconType.compare}
              cursor={'pointer'}
              fill={isHoverComp || iscompareP ? '#000000' : '#DDDDDD'}
              title={iscompareP?`${'Odstrániť z porovnania'}`:`${__('Pridať do porovnania')}`}
            />
          </StyledLink>
          : <></>
      }

      {hasFavourite && (
        <Link
          to={''}
          onMouseEnter={onSetIsHoverFav}
          onMouseLeave={offSetIsHoverFav}
          /* tslint:disable-next-line:jsx-no-lambda */
          onClick={() => {
            setIsFavoriteP(!isFavoriteP);
            addToFavorite(id);
          }}
        >
          <SvgIcon
            icon={IconType.favourites}
            cursor={'pointer'}
            fill={
              isHoverFav
                ? '#000000'
                : isFavoriteP
                ? 'rgba(255, 30, 69, 0.92)'
                : '#DDDDDD'
            }
            title={`${__('Pridať k obľúbeným')}`}
          />
        </Link>
      )}

      {showCloseIcon ? 
          <StyledLink
            onClick={() => {
              if(onClose){
                onClose(id);
              }
            }}
          >
            <SvgIcon
              icon={IconType.close}
              cursor={'pointer'}
              fill={'#000000'}
              title={`${'Odstrániť z porovnania'}`}
            />
          </StyledLink>
          : <></>
      }


    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const StyledLink = styled(Link)`
  margin-right: ${rem(8)};
`;

export { FavoriteCompare };
